<template>
  <div class="principal">
    <Carregando :estaCarregando="processando" v-if="processando" v-cloak/>

    <nav-menu v-if="!processando" />
    
    <div class="w3-main" style="margin-top:43px;" id="principal"  v-if="!processando">
      <header class="w3-container w3-white w3-center">
        <div class="w3-margin-top w3-center">
          <div class="w3-col" v-cloak>            
            <img  
              v-if="foto_usuario"
              style="width: 8rem; height: 8rem; background-size: cover" 
              v-bind:src="'data:image/jpeg;base64,'+ foto_usuario" 
              class=" w3-center w3-circle w3-border w3-margin-bottom"/>
              <br/>
          </div>

          <div class="w3-col s12" style="margin-bottom: 15px;" v-if="!foto_usuario">
            <div 
              class="circulo-letra w3-border w3-center w3-circle">
              {{getPrimeiraLetraNome(usuario_logado.nome)}}
            </div>
          </div>

          <div class="w3-col w3-display-container" style="height:5rem;" v-cloak>
            <div style="align-content: left">
          
              <span style="font-size: 16px" class="texto-cinza">Olá</span>
              <span style="font-size: 16px" class="texto-vermelho">{{usuario_logado.nome}}</span>
              <br>
              <span class="texto-preto">
                <b>{{empresa_logada.empresa_id}} - {{empresa_logada.nome_fantasia}}</b>
              </span>
            </div>
          </div>
        </div>
      </header>
      <hr>
      <div class="w3-container">
        <div class="w3-row-padding w3-center">

          <div class="w3-col s12">
            <center>
              <div class="card-item">
                <router-link 
                  to="/dashboard" 
                  class="w3-large botao-menu-principal">
                  <i style="color: #ac5555;" class="fa fa-tachometer-alt fa-fw"/>
                  <span> Dashboard</span>
                </router-link>
              </div>
            </center>
          </div>
          
          <div class="w3-col s12">
            <center>
              <div class="card-item">
                <router-link 
                  to="/mensagens" 
                  class="w3-large botao-menu-principal">
                  <i style="color: #8bc34a;" class="fa fa-envelope fa-fw"/>
                  <span> Mensagens</span>
                </router-link>
              </div>
            </center>
          </div>

          <div class="w3-col s12" v-if="usuarioCargoVendedor()">
            <center>
              <div class="card-item w3-large botao-menu-principal" @click="abrirPesquisaOrcamentos()">
                <i style="color: #ac5555;" class="fa fa-shopping-cart fa-fw"/>
                <span> Últimos pedidos</span>
              </div>
            </center>
          </div>

          <div class="w3-col s12" v-if="usuarioCargoVendedor()">
            <center>
              <div class="card-item w3-large botao-menu-principal" @click="abrirPesquisaProdutosVenda()">
                <i style="color: #8bc34a;" class="fa fa-shopping-basket fa-fw"/>
                <span> Pesquisa de produtos</span>
              </div>
            </center>
          </div>
          
        </div>
      </div>
    </div>

    <pesquisa-orcamentos 
      ref="frPesquisaOrcamentos"
      :somentePesquisar="'S'"
      :somenteUltimosPedidosVendedor="'S'"
    />

    <pesquisa-produtos-venda 
      ref="frProdutosVenda"
      :somentePesquisar="'S'"
      @adicionarCliente="adicionarCliente"
      @adicionarCondicao="adicionarCondicao"
      @limparCliente="limparCliente"
      @limparCondicaoPagamento="limparCondicaoPagamento"
      :clienteSelecionado="cliente"
      :condicaoSelecionada="condicao_pagamento"
      :parEmpQuestionarUsoPromocao="par_emp_questionar_uso_promocao"
      :percentualDescontoMaximoF5="desconto_autorizado_vendedor"
      :parEmpGerarBloqDescF5AcimaAut="par_emp_gerar_bloq_desc_f5_acima_aut"
      :parGerQtdMinCaractPesqProdutos="par_ger_qtd_min_caract_pesq_produtos"
      :parEmpQuestionarUsoPrecoAtacadoVda="par_emp_questionar_uso_pco_atacado_vda"
    />

  </div>
</template>

<script>
  import NavMenu from '@/components/Menu'
  import store from '@/ambiente/store'
  import RSessao from '@/components/Rest/RSessao'
  import Carregando from '@/components/Carregando'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  import PesquisaOrcamentos from "@/components/Pesquisas/PesquisaOrcamentos"
  import PesquisaProdutosVenda from '@/components/Pesquisas/PesquisaProdutosVenda'
  
  export default {
    name: 'Principal',
    
    components: {
      NavMenu,
      Carregando,
      PesquisaOrcamentos,
      PesquisaProdutosVenda
    },

    data () {
      return {
        quantidade_mensagens: 0,
        usuario_logado: {},
        empresa_logada: {},
        processando: true,
        foto_usuario: '',
        cliente: undefined,
        condicao_pagamento: undefined,
        desconto_autorizado_vendedor: 0,
        par_emp_gerar_bloq_desc_f5_acima_aut: 'S',
        par_emp_questionar_uso_promocao: 'S',
        par_ger_qtd_min_caract_pesq_produtos: 3,
        par_emp_questionar_uso_pco_atacado_vda: 'S'
      }
    },

    async mounted() {
      this.carregarSessao();
    },

    methods: {
      async carregarSessao() {
        if (!RSessao.carregouSessao()) {
          await RSessao.buscarDadosCarregarSessao(this.axios);
        }

        this.usuario_logado = await JSON.parse(JSON.stringify(store.state.usuario_logado));
        this.empresa_logada = await JSON.parse(JSON.stringify(store.state.empresa_logada));

        this.foto_usuario = '';
        if (store.state.foto_usuario_logado) {
          let dados_foto = await JSON.parse(JSON.stringify(store.state.foto_usuario_logado));
          if (dados_foto.foto) {
            this.foto_usuario = dados_foto.foto;
          }
        }

        await JSON.parse(JSON.stringify(store.state.empresa_logada));

        this.desconto_autorizado_vendedor = 99;

        // Parâmetros gerais
        this.par_ger_qtd_min_caract_pesq_produtos = Biblioteca.valorInt(store.state.parametros_gerais.qtd_min_caract_pesq_produtos);

        // Parâmetros de empresa
        this.par_emp_questionar_uso_promocao = store.state.parametros_empresa.questionar_uso_promocao;
        this.par_emp_gerar_bloq_desc_f5_acima_aut = store.state.parametros_empresa.gerar_bloq_desc_f5_acima_aut;
        this.par_emp_questionar_uso_pco_atacado_vda = store.state.parametros_empresa.questionar_uso_pco_atacado_vda;

        this.processando = false;
      },

      usuarioCargoVendedor(){
        if (!this.usuario_logado){
          return false;
        }

        return this.usuario_logado.cargo_id == '2';
      },

      adicionarCliente(cliente){
        this.cliente = JSON.parse(JSON.stringify(cliente));
      },

      limparCliente(){
        this.cliente = {};
      },

      adicionarCondicao(condicao_pagamento){
        this.condicao_pagamento = JSON.parse(JSON.stringify(condicao_pagamento));
      },

      limparCondicaoPagamento(){
        this.condicao_pagamento = {};
      },

      async abrirPesquisaOrcamentos(){
        await this.$refs.frPesquisaOrcamentos.abrirPesquisa(true);
      },

      async abrirPesquisaProdutosVenda(){
        Biblioteca.exclamar('Esse recurso foi migrado para o Aplicativo ADM Vendas. Entre em contato com a Santri Sistemas!')
        return;
        
        await this.$refs.frProdutosVenda.mostrarModalProdutos(
          false,
          this.cliente, 
          this.condicao_pagamento
        );
      },

      getPrimeiraLetraNome(nome){
        if (nome){
          return nome.substr(0, 1);
        } else {
          return '?';
        }
      },
    }
  }
</script>

<style scoped>
  .circulo-letra {
    width: 100px; 
    height: 100px; 
    background-color: #9c1d1c; 
    color: #f7f7f7; 
    background-size: cover; 
    font-weight: bold; 
    font-size: 60px; 
    display: inline-block; 
    padding-top: 1px;
    border: 3px solid #ebe6e6!important; 
    box-shadow: #6b6b6b 2px 2px 5px 2px;
    margin-bottom: 10px;
  }

  .card-item {
    color: #333333;
    max-width: 250px;
    background: white;
    border-radius: 30px !important;
    margin-bottom: 5px;
    padding: 5px !important;
    border: 2px solid rgb(172, 168, 168);
    background-color: #f7f7f7 !important; 
    cursor: pointer;
    font-size: 18px !important;
  }

  .card-item:hover {
    border: 1px solid #bfbfbf; 
    box-shadow: #7a7a7a 1px 2px 5px 2px;
  }

  .botao-menu-principal {
    text-decoration: none;
  }

</style>


// WEBPACK FOOTER //
// src/components/Principal.vue